import React from "react";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import LiveStream from "../live-streaming-common-components/LiveStream";
import { useLiveStream } from "../../context/LiveStreamContext";

const GoLiveView = ({ chatOpen }) => {
  const deviceSize = useDeviceSize();
  const { organizerData, loginData, isTwitchStreamingEnabled } =
    useLiveStream();

  const liveStreamId =
    organizerData?.eventDetails?.organiserID === loginData?.username
      ? organizerData?.streamDetails?.[0]?.organizerYoutubeStream?.liveStreamId
      : organizerData?.streamDetails?.[0]?.challengerYoutubeStream
          ?.liveStreamId || "";

  const LiveStreamUrl =
    organizerData?.eventDetails?.organiserID === loginData?.username
      ? organizerData?.streamDetails?.[0]?.organizerTwitchStream?.liveStreamURL
      : organizerData?.streamDetails?.[0]?.challengerTwitchStream
          ?.liveStreamURL || "";
  return (
    <LiveStream
      platform={isTwitchStreamingEnabled ? "twitch" : "youtube"}
      streamId={isTwitchStreamingEnabled ? LiveStreamUrl : liveStreamId}
      height={
        deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
          ? 200
          : chatOpen
          ? 400
          : 543
      }
      width={"100%"}
    />
  );
};

export default GoLiveView;
